// Get last item in hierarchy format.
// https://www.algolia.com/doc/api-reference/widgets/hierarchical-menu/react/#requirements
const getLabel = (label = '') => label.split(' > ').slice(-1)
export default getLabel
